export const CHANNEL_TYPE_CME_CLOUD_SEEDANCE = 68;
export const CHANNEL_TYPE_ASTRAFLOW = 69;

export const channelUsesDedicatedBaseURLField = (channelType) =>
  channelType === 50 ||
  channelType === 66 ||
  channelType === CHANNEL_TYPE_CME_CLOUD_SEEDANCE ||
  channelType === CHANNEL_TYPE_ASTRAFLOW;

export const CHANNEL_OPTIONS = [
  { key: 1, text: 'OpenAI', value: 1, color: 'green' },
  {
    key: 50,
    text: 'OpenAI 兼容',
    value: 50,
    color: 'olive',
    description: 'OpenAI 兼容渠道，支持设置 Base URL',
  },
  {key: 14, text: 'Anthropic', value: 14, color: 'black'},
  { key: 33, text: 'AWS', value: 33, color: 'black' },
  {key: 3, text: 'Azure', value: 3, color: 'olive'},
  {key: 11, text: 'PaLM2', value: 11, color: 'orange'},
  {key: 24, text: 'Gemini', value: 24, color: 'orange'},
  {
    key: 51,
    text: 'Gemini (OpenAI)',
    value: 51,
    color: 'orange',
    description: 'Gemini OpenAI 兼容格式',
  },
  { key: 28, text: 'Mistral AI', value: 28, color: 'orange' },
  { key: 41, text: 'Novita', value: 41, color: 'purple' },
  {
    key: 40,
    text: '字节火山引擎',
    value: 40,
    color: 'blue',
    description: '原字节跳动豆包',
  },
  {
    key: 15,
    text: '百度文心千帆',
    value: 15,
    color: 'blue',
    tip: '请前往<a href="https://console.bce.baidu.com/qianfan/ais/console/applicationConsole/application/v1" target="_blank">此处</a>获取 AK（API Key）以及 SK（Secret Key），注意，V2 版本接口请使用 <strong>百度文心千帆 V2 </strong>渠道类型',
  },
  {
    key: 47,
    text: '百度文心千帆 V2',
    value: 47,
    color: 'blue',
    tip: '请前往<a href="https://console.bce.baidu.com/iam/#/iam/apikey/list" target="_blank">此处</a>获取 API Key，注意本渠道仅支持<a target="_blank" href="https://cloud.baidu.com/doc/WENXINWORKSHOP/s/em4tsqo3v">推理服务 V2</a>相关模型',
  },
  {
    key: 17,
    text: '阿里通义千问',
    value: 17,
    color: 'orange',
    tip: '如需使用阿里云百炼，请使用<strong>阿里云百炼</strong>渠道',
  },
  { key: 49, text: '阿里云百炼', value: 49, color: 'orange' },
  {
    key: 18,
    text: '讯飞星火认知',
    value: 18,
    color: 'blue',
    tip: '本渠道基于讯飞 WebSocket 版本 API，如需 HTTP 版本，请使用<strong>讯飞星火认知 V2</strong>渠道',
  },
  {
    key: 48,
    text: '讯飞星火认知 V2',
    value: 48,
    color: 'blue',
    tip: 'HTTP 版本的讯飞接口，前往<a href="https://console.xfyun.cn/services/cbm" target="_blank">此处</a>获取 HTTP 服务接口认证密钥',
  },
  { key: 16, text: '智谱 ChatGLM', value: 16, color: 'violet' },
  { key: 19, text: '360 智脑', value: 19, color: 'blue' },
  { key: 25, text: 'Moonshot AI', value: 25, color: 'black' },
  { key: 23, text: '腾讯混元', value: 23, color: 'teal' },
  { key: 26, text: '百川大模型', value: 26, color: 'orange' },
  { key: 27, text: 'MiniMax', value: 27, color: 'red' },
  { key: 29, text: 'Groq', value: 29, color: 'orange' },
  { key: 30, text: 'Ollama', value: 30, color: 'black' },
  { key: 31, text: '零一万物', value: 31, color: 'green' },
  { key: 32, text: '阶跃星辰', value: 32, color: 'blue' },
  { key: 34, text: 'Coze', value: 34, color: 'blue' },
  { key: 35, text: 'Cohere', value: 35, color: 'blue' },
  { key: 36, text: 'DeepSeek', value: 36, color: 'black' },
  { key: 37, text: 'Cloudflare', value: 37, color: 'orange' },
  { key: 38, text: 'DeepL', value: 38, color: 'black' },
  { key: 39, text: 'together.ai', value: 39, color: 'blue' },
  { key: 42, text: 'VertexAI', value: 42, color: 'blue' },
  { key: 43, text: 'Proxy', value: 43, color: 'blue' },
  { key: 44, text: 'SiliconFlow', value: 44, color: 'blue' },
  { key: 45, text: 'xAI', value: 45, color: 'blue' },
  { key: 46, text: 'Replicate', value: 46, color: 'blue' },
  {
    key: 8,
    text: '自定义渠道',
    value: 8,
    color: 'pink',
    tip: '不推荐使用，请使用 <strong>OpenAI 兼容</strong>渠道类型。注意，这里所需要填入的代理地址仅会在实际请求时替换域名部分，如果你想填入 OpenAI SDK 中所要求的 Base URL，请使用 OpenAI 兼容渠道类型',
    description: '不推荐使用，请使用 OpenAI 兼容渠道类型',
  },
  { key: 22, text: '知识库：FastGPT', value: 22, color: 'blue' },
  { key: 21, text: '知识库：AI Proxy', value: 21, color: 'purple' },
  { key: 20, text: 'OpenRouter', value: 20, color: 'black' },
  { key: 2, text: '代理：API2D', value: 2, color: 'blue' },
  { key: 5, text: '代理：OpenAI-SB', value: 5, color: 'brown' },
  { key: 7, text: '代理：OhMyGPT', value: 7, color: 'purple' },
  { key: 10, text: '代理：AI Proxy', value: 10, color: 'purple' },
  { key: 4, text: '代理：CloseAI', value: 4, color: 'teal' },
  { key: 6, text: '代理：OpenAI Max', value: 6, color: 'violet' },
  { key: 9, text: '代理：AI.LS', value: 9, color: 'yellow' },
  { key: 12, text: '代理：API2GPT', value: 12, color: 'blue' },
  { key: 13, text: '代理：AIGC2D', value: 13, color: 'purple' },
  { key: 52, text: '火山视觉', value: 52, color: 'blue' },
  { key: 53, text: '可灵', value: 53, color: 'purple' },
  { key: 54, text: 'liblibai', value: 54, color: 'green' },
  { key: 55, text: 'runninghub', value: 55, color: 'teal' },
  { key: 56, text: '火山语音', value: 56, color: 'teal' },
  { key: 57, text: '拍我AI', value: 57, color: 'yellow' },
  { key: 58, text: '贞贞的AI工坊', value: 58, color: 'teal' },
  { key: 59, text: 'MaasAI', value: 59, color: 'yellow' },
  { key: 60, text: 'ToAPIs', value: 60, color: 'blue' },
  { key: 61, text: 'Suno', value: 61, color: 'orange' },
  {
    key: 62,
    text: '百度可灵',
    value: 62,
    color: 'blue',
    tip: '请使用与 <strong>百度文心千帆 V2</strong> 相同的 Base URL 和鉴权配置；该渠道将用于承载百度可灵与 lip-sync 相关模型。',
  },
  {
    key: 63,
    text: 'AgentsFlare',
    value: 63,
    color: 'teal',
    description: '支持视频生成，使用 Bearer Token 鉴权',
  },
  {
    key: 64,
    text: 'DimiLinks',
    value: 64,
    color: 'blue',
    description: '支持 gpt-image-2 异步图片生成与任务查询',
  },
  {
    key: 65,
    text: 'DeepSeek 官方',
    value: 65,
    color: 'black',
    description: 'DeepSeek 官方 API，使用 DeepSeek-V4-Flash/DeepSeek-V4-Pro 对外模型名',
  },
  {
    key: 66,
    text: 'Anthropic 兼容',
    value: 66,
    color: 'black',
    description: 'Anthropic 兼容渠道，使用 /v1/messages 接口格式，支持设置自定义 Base URL',
  },
  {
    key: 67,
    text: 'Topaz Labs',
    value: 67,
    color: 'pink',
    description:
      '图像/视频超分渠道，使用 X-API-Key 鉴权；模型如 topaz-standard-v2、topaz-apollo-v8 等；需要先配置国内阿里云 OSS 用于源文件转存',
  },
  {
    key: CHANNEL_TYPE_CME_CLOUD_SEEDANCE,
    text: '移动云 Seedance',
    value: CHANNEL_TYPE_CME_CLOUD_SEEDANCE,
    color: 'blue',
    tip: 'Base URL 请填写移动云控制台提供的 cmecloud.cn 区域地址（须为 HTTPS，通常以 /api/v3 结尾）；密钥使用 Bearer Token。结果文件加密已关闭，任务成功后直接返回约 24 小时有效的视频 URL。',
    description:
      '移动云机密模型 Seedance 渠道；请求通过官方 SDK 完成远程证明和传输加密',
  },
  {
    key: CHANNEL_TYPE_ASTRAFLOW,
    text: 'AstraFlow',
    value: CHANNEL_TYPE_ASTRAFLOW,
    color: 'blue',
    description:
      'ModelVerse优刻得 聚合平台渠道，支持图片、视频及 Jev/Laya 结构化决策，使用 Bearer Token 鉴权，支持设置 Base URL',
  },
];
